import { type AxiosPromise } from 'axios';
import { httpServices } from './config';
import { type Empresa } from '../interfaces/User.interface';

const rutEnterprise = localStorage.getItem('rutEnterprise')!;

export const getPerRut = (
	rutToSearch: string | '',
	token: string,
): AxiosPromise<Empresa> => {
	return httpServices.get(`/inicio/v1/empresa/empresa/${rutToSearch}`, {
		headers: {
			Authorization: `Bearer ${token}`,
			'ms-company-id': rutEnterprise,
		},
	});
};

export const getEquipoCuenta = (
	rut: string,
	bps: string,
	token: string,
): AxiosPromise => {
	return httpServices.get(
		`/inicio/v1/empresa/equipos?RUT=${rut}&bpCuenta=${bps}`,
		{
			headers: {
				Authorization: `Bearer ${token}`,
				'ms-company-id': rutEnterprise,
			},
		},
	);
};

export const getExcelFile = (
	rut: string,
	input: string,
	regiones: string,
	token: string,
): AxiosPromise => {
	return httpServices.get(
		`/empresa/v1/sf-empresa/exportExcelSucursales?RUT=${rut}&filtro=${input}&regiones=${regiones}`,
		{
			headers: {
				Authorization: `Bearer ${token}`,
				'ms-company-id': rutEnterprise,
			},
		},
	);
};

export const getResources = (token: string): AxiosPromise => {
	return httpServices.get('/inicio/v1/usuario/recursos', {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
};
